export default __webpack_public_path__ + "static/media/THERE.4e56fc45.mp3";